import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import { dynamicAPIImage } from "../../../Utils";
import { useQuery } from "@tanstack/react-query";
import { H5, Image, LI, P, UL } from "../../../AbstractElements";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import ScrollBar from "react-perfect-scrollbar";
import DOMPurify from "dompurify";

//TYPE
import { ViewApplicantNotesByApplNo } from "../../../Types/Applicants/ApplicantsNotes";

//SERVICES
import {
  VIEW_APPLNOTES_QUERY_KEY,
  applicantNotesService,
} from "../../../Services/applicantsnotesService";

interface CandidateProfileProps {
  ApplNo: string;
}

const Remarks: React.FC<CandidateProfileProps> = ({ ApplNo }) => {
  const { data: noteData = [], isLoading: isFetching } = useQuery<
    ViewApplicantNotesByApplNo[]
  >({
    queryKey: [...VIEW_APPLNOTES_QUERY_KEY, ApplNo],
    queryFn: () => applicantNotesService.viewByApplication(ApplNo as string),
  });

  return (
    <Col sm="12">
      <Card className="card-absolute">
        <CommonCardHeader
          headClass="bg-primary"
          tagClass="txt-light"
          icon={<i className="icofont icofont-notepad me-1"></i>}
          title={"Remarks / Notes"}
        />
        <CardBody>
          <ScrollBar className="vertical-scroll custom-container border shadow-sm rounded p-2 mb-2">
            <div className="msger-chat" style={{ height: "700px" }}>
              <UL className="simple-list mt-4 mx-4">
                {noteData?.map((item, index) => (
                  <LI
                    key={index}
                    className=" rounded-3 shadow-sm bg-white p-3 mt-3"
                  >
                    <div className="d-flex">
                      <Image
                        className="rounded-square border"
                        width={60}
                        height={60}
                        src={
                          dynamicAPIImage(item.profile_url) ||
                          "user-profile/default.png"
                        }
                        alt="Profile Picture"
                      />

                      <div className="flex-grow-1 ms-3">
                        {/* Header */}
                        <div className="d-flex justify-content-between align-items-start">
                          <div>
                            <H5 className="mb-1 fw-semibold">
                              {item.updated_by_user}
                            </H5>

                            <P>{"( " + item.updated_date + " )"}</P>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Note */}
                    <div className="border-top p-3 mt-3">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(item.notes),
                        }}
                      />
                    </div>
                  </LI>
                ))}
                <LI>
                  <center>
                    <br></br>*** Nothing Follows ***
                  </center>
                </LI>
              </UL>
            </div>
          </ScrollBar>
        </CardBody>
      </Card>
    </Col>
  );
};
export default Remarks;
